// extracted by mini-css-extract-plugin
export default {"wrapperBonusLoader":"BonusCancelLoader_wrapperBonusLoader__3y6sW","size":"BonusCancelLoader_size__8OZMb"};